import { app } from '@/main';
import moment from 'moment';

// dayjs
import dayjs from 'dayjs';
// dayjs - locales
import 'dayjs/locale/en';
import 'dayjs/locale/ja';

export const changeLanguage = locale => {
  // i18n
  app.$i18n.locale = locale;

  // moment.js
  const momentLang = {
    en: 'en-us',
    ja: 'ja',
    zh_cn: 'zh-cn',
  };
  moment.locale(momentLang[locale]);

  // dayjs
  dayjs.locale(locale);

  // Quasar language
  const quasarLang = {
    en: 'en-us',
    ja: 'ja',
    zh_cn: 'zh-hans',
  };
  import(`quasar/lang/${quasarLang[locale]}`).then(val => {
    app.$q.lang.set(val.default);
  });

  // Async validator??
  app.$validator.localize(locale);
};
